/* The MIT License (MIT)

Copyright (c) 2015 Textalk

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

// Fake localStorage implementation.
// Mimics localStorage, including events.
// It will work just like localStorage, except for the persistant storage part.

const initFakeLocalStorage = () => {
	let fakeLocalStorage = {};
	let storage;

	// If Storage exists we modify it to write to our fakeLocalStorage object instead.
	// If Storage does not exist we create an empty object.
	if (window.Storage && window.localStorage) {
		storage = window.Storage.prototype;
	} else {
		// We don't bother implementing a fake Storage object
		window.localStorage = {};
		storage = window.localStorage;
	}

	// For older IE
	if (!window.location.origin) {
		window.location.origin = `${window.location.protocol}//${
			window.location.hostname
		}${window.location.port ? `:${window.location.port}` : ''}`;
	}

	const dispatchStorageEvent = (key, newValue) => {
		const oldValue = key == null ? null : storage.getItem(key); // `==` to match both null and undefined
		const url = window.location.href.substr(window.location.origin.length);
		const storageEvent = document.createEvent('StorageEvent'); // For IE, http://stackoverflow.com/a/25514935/1214183

		storageEvent.initStorageEvent(
			'storage',
			false,
			false,
			key,
			oldValue,
			newValue,
			url,
			null
		);
		window.dispatchEvent(storageEvent);
	};

	storage.key = i => {
		const key = Object.keys(fakeLocalStorage)[i];
		return typeof key === 'string' ? key : null;
	};

	storage.getItem = key => {
		return typeof fakeLocalStorage[key] === 'string'
			? fakeLocalStorage[key]
			: null;
	};

	storage.setItem = (key, value) => {
		dispatchStorageEvent(key, value);
		fakeLocalStorage[key] = String(value);
	};

	storage.removeItem = key => {
		dispatchStorageEvent(key, null);
		delete fakeLocalStorage[key];
	};

	storage.clear = () => {
		dispatchStorageEvent(null, null);
		fakeLocalStorage = {};
	};
};

// Example of how to use it
if (typeof window.localStorage === 'object') {
	// Safari will throw a fit if we try to use localStorage.setItem in private browsing mode.
	try {
		localStorage.setItem('localStorageTest', 1);
		localStorage.removeItem('localStorageTest');
	} catch (e) {
		initFakeLocalStorage();
	}
} else {
	// Use fake localStorage for any browser that does not support it.
	initFakeLocalStorage();
}
